<script>
export default {
    props: {
        actionHistoryItemId: {
            type: Number,
            required: true,
        },
        hstActionSyncStatuses: {
          type: Object,
          required: true
        }
    }
}
</script>

<template>
  <!-- Real HST failures are red. "Lead Doesnt belong to Agent" (not_owned) used to be hidden
       here, which left agents guessing why a step never reached HST (CU-868mkxvfd). HST answers
       it for every step on a lead it has taken back, so it shows as a quiet gray note instead. -->
  <div v-if="typeof hstActionSyncStatuses?.errors?.[actionHistoryItemId] !== 'undefined'">
    <div class="mt-2">
      <p class="text-red-600 font-semibold">
        HST Sync Error<span v-if="hstActionSyncStatuses.errors[actionHistoryItemId]">: <em>{{ hstActionSyncStatuses.errors[actionHistoryItemId] }}</em></span>
      </p>
    </div>
  </div>
  <div v-else-if="hstActionSyncStatuses?.not_owned?.[actionHistoryItemId]">
    <div class="mt-2">
      <p class="text-gray-500">Not recorded in HST: HST did not list this agent as the lead's owner.</p>
    </div>
  </div>
  <div v-else-if="typeof hstActionSyncStatuses?.ok?.[actionHistoryItemId] !== 'undefined'">
    <div class="mt-2">
      <p class="text-green-600 font-semibold">Synced to HST</p>
    </div>
  </div>
  <!-- Booking an appointment posts it to HST separately from completing it; the id HST
       returned is the proof that the booking arrived. -->
  <div v-if="hstActionSyncStatuses?.appointments?.[actionHistoryItemId]">
    <div class="mt-2">
      <p class="text-green-600 font-semibold">Appointment synced to HST (Appt ID {{ hstActionSyncStatuses.appointments[actionHistoryItemId] }})</p>
    </div>
  </div>
</template>